import React from "react";


import {

Dialog,

DialogTitle,

DialogContent,

DialogActions,

Button,

Typography,

CircularProgress,

Checkbox,

FormControlLabel

} from "@mui/material";




function DeleteDepartmentDialog({

open,

department,

onClose,

onConfirm,

isDeleting = false,

deleteRelated = false,

onToggleDeleteRelated

}) {



return (


<Dialog

open={open}

onClose={onClose}

disableEscapeKeyDown={isDeleting}

maxWidth="xs"

fullWidth

>



<DialogTitle

fontWeight={600}

>

Delete Department

</DialogTitle>






<DialogContent>


<Typography>

Are you sure you want to delete

<b>

&nbsp;{department?.department_name}

</b>

?

</Typography>

<FormControlLabel

sx={{

mt:1

}}

control={

<Checkbox

checked={deleteRelated}

onChange={(event)=>onToggleDeleteRelated?.(event.target.checked)}

disabled={isDeleting}

/>

}

label="Delete all related records"

/>


</DialogContent>







<DialogActions>


<Button

onClick={onClose}

disabled={isDeleting}

sx={{

textTransform:"none"

}}

>

Cancel

</Button>






<Button

color="error"

variant="contained"

onClick={onConfirm}

disabled={isDeleting}

startIcon={
isDeleting
? <CircularProgress size={16} color="inherit" />
: null
}

sx={{

textTransform:"none"

}}

>

{
isDeleting
? "Deleting..."
: "Delete"
}

</Button>



</DialogActions>



</Dialog>


);


}


export default DeleteDepartmentDialog;